<template>
  <div class="row p-list-representation-wrapper align-items-start w-100">
    <div class="row w-100 p-list-representation-province-main pr-4 pl-4">

      <div class="w-100 d-flex flex-wrap p-list-representation-province-data-item mt-4 mb-4">

      </div>

      <div class=" d-flex flex-wrap p-list-representation-province-data-item w-100">
        <div class="row w-100 flex-column flex-lg-row">
          <formData
          :form-data-original="formData"
          :cups-data="cupsData"
          :players-data="playersData"
          :selected-player="selectedPlayer"
          :selected-cup="selectedCup"

          @submitData="submitData"
          ></formData>
        </div>
      </div>

    </div>


  </div>
</template>

<script>
import formData from './formData';


export default {
  name: "contentList",
  components: {
    formData,
  },

  props: {
    formData        : {type:Object,default:{}},
    cupsData        : {type:[Object,Array],default:[]},
    playersData     : {type:[Object,Array],default:[]},
    selectedPlayer  : {type:[Object,Array],default:[]},
    selectedCup     : {type:[Object,Array],default:[]},


  },

  data() {
    return {

    }
  },

  watch: {

  },

  created() {

  },

  mounted() {
  },

  methods: {
    submitData(data){
      this.$emit('submitData',data);
    },

  }


}
</script>
